import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';

import { APP_CONFIG } from '../config';
import { IAppConfig } from '../../store/interfaces';
import { LogService } from '../services/logging.service';
import { ApigeeDAO } from './apigee.dao';
import { IPointsEstimationParams } from '../interfaces';
import { PointsEstimationDataValidator } from './validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';

const CLASS_NAME = 'PointsEstimationDao';

@Injectable()
export class PointsEstimationDao extends ApigeeDAO {

  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.pointsEstimationDAO, new DefaultRetryHandler(), new PointsEstimationDataValidator(), log, cookieService);
  }

  get(parameters: IPointsEstimationParams): Observable<any> {
    const url = this.daoConfig.url;
    return super.doGet(url, parameters);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/points-estimation.dao.ts